export const diasPorMes = {
    'Enero' : 31,
    'Febrero' : 28,
    'Marzo' : 31,
    'Abril' : 30,
    'Mayo' : 31,
    'Junio' : 30,
    'Julio' : 31,
    'Agosto' : 31,
    'Septiembre' : 30,
    'Octubre' : 31,
    'Noviembre' : 30,
    'Diciembre': 31
};

export const numMes = {
    'Enero' : 0,
    'Febrero' : 1,
    'Marzo' : 2,
    'Abril' : 3,
    'Mayo' : 4,
    'Junio' : 5,
    'Julio' : 6,
    'Agosto' : 7,
    'Septiembre' : 8,
    'Octubre' : 9,
    'Noviembre' : 10,
    'Diciembre': 11
};

export const monthBirthdateOptions = [
    {
        value: "Enero"
    },
    {
        value: "Febrero"
    },
    {
        value: "Marzo"
    },
    {
        value: "Abril"
    },
    {
        value: "Mayo"
    },
    {
        value: "Junio"
    },
    {
        value: "Julio"
    },
    {
        value: "Agosto"
    },
    {
        value: "Septiembre"
    },
    {
        value: "Octubre"
    },
    {
        value: "Noviembre"
    },
    {
        value: "Diciembre"
    }
]

export const yearBirthdateOptions = [1985, 1986, 1987, 1988, 1989, 1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003, 2004, 2005]

export const yearOptions = [
    {
        value: "1er año"
    },
    {
        value: "2do año"
    },
    {
        value: "3er año"
    },
    {
        value: "4to año"
    },
    {
        value: "5to año"
    }
]

export const areaOptions = [
    {
        value: "Administración"
    },
    {
        value: "Analytics"
    },
    {
        value: "Comercial"
    },
    {
        value: "Estrategia"
    },
    {
        value: "Economía Financiera"
    },
    {
        value: "Evaluación de Proyectos"
    },
    {
        value: "Fidelización"
    },
    {
        value: "Finanzas"
    },
    {
        value: "Gestión"
    },
    {
        value: "Innovación y Emprendimiento"
    },
    {
        value: "Inteligencia Artificial"
    },
    {
        value: "Inversiones"
    },
    {
        value: "Investigación y Docencia"
    },
    {
        value: "Investigación de Mercados"
    },
    {
        value: "Jurídica"
    },
    {
        value: "Logística"
    },
    {
        value: "Macroeconomía Aplicada"
    },
    {
        value: "Marketing"
    },
    {
        value: "Mesa de Dinero"
    },
    {
        value: "Negocios"
    },
    {
        value: "Operaciones"
    },
    {
        value: "Reclutamiento y Selección"
    },
    {
        value: "Responsabilidad Social Empresarial"
    },
    {
        value: "RRHH"
    },
    {
        value: "Supply Chain"
    },
    {
        value: "Ventas"
    },
    {
        value: "Otros"
    }
];

export const industryOptions = [
    {
        value: "Arte y Cultura"
    },
    {
        value: "Asesoría"
    },
    {
        value: "Banca Corporativa"
    },
    {
        value: "Banca Inversiones"
    },
    {
        value: "Educación"
    },
    {
        value: "Capacitación"
    },
    {
        value: "Ciencias Sociales"
    },
    {
        value: "Comercio Exterior"
    },
    {
        value: "Consultoría Estratégica"
    },
    {
        value: "Consultoría de RRHH"
    },
    {
        value: "Consumo Masivo"
    },
    {
        value: "Contabilidad Tributaria"
    },
    {
        value: "Corredora de Bolsa"
    },
    {
        value: "E-commerce"
    },
    {
        value: "Educación"
    },
    {
        value: "Economía"
    },
    {
        value: "Emprendimiento"
    },
    {
        value: "Exportación"
    },
    {
        value: "Finanzas"
    },
    {
        value: "Gobierno y ONG"
    },
    {
        value: "Informática"
    },
    {
        value: "Investigación"
    },
    {
        value: "Laboratorio y Farmacéutica"
    },
    {
        value: "Marketing y Publicidad"
    },
    {
        value: "Medios"
    },
    {
        value: "Minería y Energía"
    },
    {
        value: "Negocios"
    },
    {
        value: "Políticas Públicas"
    },
    {
        value: "Retail"
    },
    {
        value: "Salud y Ciencias"
    },
    {
        value: "Start-up"
    },
    {
        value: "Tecnología"
    },
    {
        value: "Textil"
    },
    {
        value: "Otros"
    }
];